import { registerTaskComparitor } from "routes/schedule/compare/register-task-comparitor"
import { RichTextDifference } from "routes/schedule/compare/rich-text-difference"
import { TextDifference } from "routes/schedule/compare/text-difference"
import { ifNotSameText } from "./ifNotSameText"

registerTaskComparitor("title", () => <TextDifference path="title" label={`title`} />)

registerTaskComparitor(
    "content",
    ifNotSameText(() => <RichTextDifference path="content" label={`content`} normalizeHtml />)
)

registerTaskComparitor(
    "note",
    ifNotSameText(() => <RichTextDifference path="note" label={`notes`} normalizeHtml />)
)
